// Preferências de aparência: cor do tema (rosa, azul, grafite) e modo (automático, claro, escuro).
// O tema "grafite" é somente claro. A escolha fica salva no navegador.
export const TEMAS = [
  { chave: "rosa", nome: "Rosa", descricao: "Cor da marca Vote Assembleia", escuro: true },
  { chave: "azul", nome: "Azul", descricao: "Visual frio e corporativo", escuro: true },
  { chave: "grafite", nome: "Grafite", descricao: "Sóbrio, somente modo claro", escuro: false },
];

export const MODOS = [
  { chave: "auto", nome: "Automático" },
  { chave: "claro", nome: "Claro" },
  { chave: "escuro", nome: "Escuro" },
];

const CHAVE = "va-aparencia";
const PADRAO = { tema: "rosa", modo: "claro" };

export const lerPreferencias = () => {
  try {
    const salvo = JSON.parse(window.localStorage.getItem(CHAVE) || "null");
    if (salvo && TEMAS.some(t => t.chave === salvo.tema) && MODOS.some(m => m.chave === salvo.modo)) return salvo;
  } catch (e) {
    // sem localStorage ou valor inválido: usa o padrão
  }
  return { ...PADRAO };
};

const sistemaEscuro = () =>
  !!(window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches);

// modo efetivo: temas sem modo escuro sempre ficam claros
export const resolverModo = ({ tema, modo }) => {
  const def = TEMAS.find(t => t.chave === tema) || TEMAS[0];
  if (!def.escuro) return "claro";
  if (modo === "auto") return sistemaEscuro() ? "escuro" : "claro";
  return modo;
};

export const aplicarTema = prefs => {
  const raiz = document.documentElement;
  raiz.setAttribute("data-tema", prefs.tema);
  raiz.setAttribute("data-modo", resolverModo(prefs));
};

export const salvarPreferencias = prefs => {
  try {
    window.localStorage.setItem(CHAVE, JSON.stringify(prefs));
  } catch (e) {
    // preferência vale só nesta sessão
  }
  aplicarTema(prefs);
  // avisa outros componentes (ex.: tela de Aparência) para sincronizarem a escolha
  window.dispatchEvent(new CustomEvent("va-tema-alterado", { detail: prefs }));
};

// chamado uma vez ao iniciar o app; acompanha o sistema quando o modo é automático
export const iniciarTema = () => {
  aplicarTema(lerPreferencias());
  if (window.matchMedia) {
    const consulta = window.matchMedia("(prefers-color-scheme: dark)");
    const atualizar = () => aplicarTema(lerPreferencias());
    if (consulta.addEventListener) consulta.addEventListener("change", atualizar);
    else if (consulta.addListener) consulta.addListener(atualizar);
  }
};
